/**
 * Program: newline to html br tag
 * Author: SDL
 * Description: Changed to open character html br tag
 */
import _ from 'lodash';

export default str => _.replace(str, /(\r?\n)/g, '<br/>');



// WEBPACK FOOTER //
// ./src/filters/nl2br.js